import { transformArrayType, useSpDropdownType } from '@/types/components/molecules/SpDropdown'
import { useEffect, useState } from 'react'

export const useSpDropdown: useSpDropdownType = ({
  useBodyAsAnchor,
  valueKeyName,
  options,
  labelKeyName,
  onChange,
  onBlur,
  isMulti,
  value,
  onKeyDown
}) => {
  const [anchor, setAnchor] = useState(null)

  useEffect(() => {
    if (useBodyAsAnchor) {
      setAnchor(document.body)
    }
  }, [])

  // ** Helps to transform the options array to a valid React-select  'options array'
  const transformOptionsArray: transformArrayType = () => {
    if (!options) return
    return options?.map((value) => {
      const newObject = {
        value: value[valueKeyName] || value.value,
        label: value[labelKeyName] || value.label,
        classes: value.classes || '',
      }

      return newObject
    })
  }
  const handledOptions = transformOptionsArray()

  //  ** The filteredOptionLabelSelected handle the label selected base
  // ** on if the dropdown is controlled , if it is not it will look for
  // ** `value[valueKeyName]` in the other case it will look just for the numeric value like o.value == value

  const filteredOptionLabelSelected = handledOptions?.find((o) => {
    const controlAssertion = o.value == value
    const unControlledAssertion = value && o.value == value[valueKeyName]
    return unControlledAssertion || controlAssertion
  })
  const singleValue = {
    value: value === 0 ? '0' : (value && value[valueKeyName]) || value,
    label: filteredOptionLabelSelected?.label || '',
  }

  let multipleValue
  if (isMulti) {
    const newMultiValueMapped = value?.map((itemValue) => {
      const actualValue = handledOptions?.find((o) => o.value == itemValue)

      return actualValue
    })

    multipleValue = newMultiValueMapped
  }

  const handleChange = (e) => {
    if (!onChange) return
    if (isMulti) {
      //**return just the array of values and not the completed array with label for better usability */
      const mappedMultiValueArray = e.map((value) => {
        return value?.value
      })

      onChange(mappedMultiValueArray)
    } else {
      onChange(e.value)
    }
  }

  const handleOnBlur = (e) => {
    if (!onBlur) return
    onBlur(e)
  }

  const handleKeyDown = (ev: React.KeyboardEvent) => {
    if (onKeyDown) {
      onKeyDown(ev); 
    }
  };

  return {
    anchor,
    handleChange,
    handleOnBlur,
    handledOptions,
    handleKeyDown,
    handledValue: isMulti ? multipleValue : singleValue.value ? singleValue : '',
  }
}
